import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from "../utils/axiosInstance";
import './contact.css';
import axios from 'axios';


function Contact({user}) {
    const API_URL = process.env.REACT_APP_ENV;
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false); 
    const [formData, setFormData] = useState({
        first_name: user?.first_name ||'',
        last_name:user?.last_name ||'',
        email: user?.email ||'',
        phone: user?.phone ||'',
        subject:'',
        message: ''
    });
    const [error, setError] = useState('');
    useEffect(() => {
        const fetchUser = async () => {
    try {
      const response = await axiosInstance.get(`${API_URL}/me`);
      const userInfo = response.data;

      setFormData(prev => ({
        ...prev,
        first_name: userInfo.first_name || '',
        last_name: userInfo.last_name || '',
        email: userInfo.email || '',
        phone: userInfo.phone || '',
      }));
    } catch (err) {
      console.error("Failed to fetch user", err);
    }
  };

  if (user) {
    fetchUser();
  }
}, [user]);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await axiosInstance.post(`${API_URL}/contact`, formData);
            console.log("Form submitted successfully");
    
            // Redirect to a confirmation page
            navigate('/contact-confirmation');
        } catch (error) {
            if (error.response) {
                const status = error.response.status;
                if (status === 422) {
                setError("Please enter a valid email address or check your input.");
                } else if (status === 400) {
                setError(error.response.data.detail);
                } else {
                setError("Failed to send contact form:", error);
                }
        } else {
            setError("Network error. Please try again.");
        }
        }
    };

    return(
        <div className="contact-container">
            <div className = 'contact-header'>
                    <h1>Contact Us</h1>
                    <p>Any question or remarks? Just write us a message!</p>
            </div>
            <div className="contact-card">
                <div className="left-column">
                    <h2>Talk with us</h2>
                    <p>Questions, comments, or suggestions? Simply fill in the form and we'll be in touch shortly.</p>
                    <p><strong>📧 contact.faams@gmail.com</strong></p>
                </div>

                <form className="right-column" onSubmit={handleSubmit}>
                    <div className="input-row">
                        <div className="input-group">
                            <label>First Name</label>
                            <input type="text" name="first_name" value={formData.first_name} onChange={handleChange} />
                        </div>
                        <div className="input-group">
                            <label>Last Name</label>
                            <input type="text" name="last_name" value={formData.last_name} onChange={handleChange} />
                        </div>
                    </div>

                    <div className="input-row">
                        <div className="input-group">
                            <label>Email</label>
                            <input type="email" name="email" value={formData.email} onChange={handleChange} />
                        </div>
                        <div className="input-group">
                            <label>Phone Number</label>
                            <input type="tel" name="phone" value={formData.phone} onChange={handleChange} />
                        </div>
                    </div>

                    <div className="subject-group">
                        <label>Select Subject?</label>
                        <div className="radio-group">
                            {["General Inquiry", "Scholarships", "Mentorship", "Donation"].map((option) => (
                                <label key={option}>
                                    <input
                                        type="radio"
                                        name="subject"
                                        value={option}
                                        checked={formData.subject === option}
                                        onChange={handleChange}
                                    />
                                    {option}
                                </label>
                            ))}
                        </div>
                    </div>

                    <div className="input-group">
                        <label>Message</label>
                        <textarea name="message" placeholder="Write your message.." value={formData.message} onChange={handleChange} />
                    </div>

                    <button className='contact-submit-button' type="submit" disabled={loading}>
                        {loading ? 'Sending Message...' : 'Send Message'}
                        </button>
                </form>
            </div>
        </div>
    );

}

export default Contact;